import { useStoreState } from '@/store';

import { features, getAddressMetaKey } from '@/lib';

export const usePrimaryResidentialAddressValue = (): string | null => {
  const addressMetaKey = getAddressMetaKey();

  // We need address metadata from griffin to check the required fields
  // We only show Residential Address after Billing Address filled
  const addressMeta = useStoreState(
    ({ api }) => api.griffinMetadata.address[addressMetaKey],
  );
  const residentialAddress = useStoreState(
    ({ form }) => form.residentialAddress,
  );

  // If feature is inactive or we don't have it in the store
  // we don't return value for it not to render
  if (
    !features.isActive('hasPrimaryResidentialAddress') ||
    !addressMeta ||
    !residentialAddress
  ) {
    return null;
  }

  // If the Residential Address is dirty, we show it
  if (!residentialAddress.isDirty) {
    const someIsInvalid = addressMeta.layout
      .filter(field => field.isRequired)
      .some(({ name }) => {
        // @ts-expect-error Fix form state
        const field = residentialAddress[name];

        return field.isValid === false && field.errorCode === 'valueMissing';
      });

    if (someIsInvalid) {
      // If some input is invalid, we cannot send value for it not to render
      return null;
    }
  }

  return `${residentialAddress.line1.value}, ${residentialAddress.postalCode.value}`;
};
